import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { Driver } from 'contracts/Drivers';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_DRIVER_',
  }
);

export interface FetchDriverState {
  data: Driver | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchDriverRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Driver;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchDriverState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchDriverState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchDriverState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchDriverState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchDriverState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchDriver = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchDriverTypes = Types;
export const FetchDriverActions = Creators;
